import { render, staticRenderFns } from "./ShipmentAccessPoints.vue?vue&type=template&id=6816e7a0&scoped=true&"
import script from "./ShipmentAccessPoints.vue?vue&type=script&lang=ts&"
export * from "./ShipmentAccessPoints.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentAccessPoints.vue?vue&type=style&index=0&id=6816e7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6816e7a0",
  null
  
)

export default component.exports